export default __webpack_public_path__ + "static/media/drawer_nw.975dcae0.svg";